import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';

import { PlacementContext } from 'src/types/PlacementContext';

type BannerType = 'Hero banner' | 'Standard banner';
type ElementType = 'CTA' | 'Link';

export const trackImpression = (placementContext: PlacementContext, bannerType: BannerType) => {
  const { trackingTitle, trackingPosition } = placementContext;

  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${trackingPosition} | ${bannerType}`,
    event_label: `${trackingPosition} | ${trackingTitle}`.toLowerCase(),
    event_name: 'view_content',
    content_position: `${trackingPosition}`,
    content_type: `${bannerType}|${trackingTitle}`.toLowerCase(),
  });
};

export const trackLinkClick = (
  e: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
  placementContext: PlacementContext,
  bannerType: BannerType,
  elementType: ElementType,
) => {
  const { trackingPosition, trackingTitle } = placementContext;
  const element = getAnchorElementFromEvent(e);

  if (element) {
    const trackingEvent = {
      event: 'custom_event',
      event_action: `${elementType} click`,
      event_category: `${trackingPosition} | ${bannerType}`,
      event_label: `${trackingPosition} | ${trackingTitle} | ${elementType}`.toLowerCase(),
      event_name: 'select_content',
      event_details: `${elementType} click`.toLowerCase(),
      content_position: `${trackingPosition}`,
      content_type: `${bannerType}|${trackingTitle}`.toLowerCase(),
      destination_URL: element.href,
    };

    sendGALinkClickEvent(e, trackingEvent);
  }
};
